<template>
  <div class="app limited">
    <div class="app-body">
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import { Footer as AppFooter, Breadcrumb } from '../components/'

export default {
  name: 'limited',
  components: {
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>

<style>
  .limited .app-body {
    margin-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// Limited.vue?e27889e8